import { defineStore } from 'pinia'
import { TeamableOptions } from '@/Support/Teams/Interfaces/TeamableOptions'
import { InformationCircleIcon } from '@heroicons/vue/24/outline'
import SelectTeamables from '@/Components/App/Teams/SelectTeamables.vue'

interface State extends TeamableOptions {
  selectTeamablesModal: InstanceType<typeof SelectTeamables> | null
}

const defaultState: State = {
  modelType: '',
  modelId: '',
  title: '',
  description: null,
  routeParams: {},
  wide: false,
  showName: false,
  relationshipParents: false,
  icon: InformationCircleIcon,
  multiple: true,
  onSelected: () => {},
  onClose: () => {},
  showSelectTeamables: false,
  idsTeamablesSelected: false,
  selectTeamablesModal: null,
  relationshipAction: null,
}

export const useSelectTeamables = defineStore('selectTeamables', {
  state: (): State => {
    return defaultState
  },
  actions: {
    async selectTeamables(options: TeamableOptions) {
      this.$reset()
      this.idsTeamablesSelected = false
      for (const [key, value] of Object.entries(options)) {
        this[key] = value
      }
      this.selectTeamablesModal?.open()
    },
  },
})
